import FinancialAccountItem from "./FinancialAccountItem";

export default FinancialAccountItem;
